function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "306DA599-B0AB-493E-BE84-D1C2B1D2FD4B");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Design-System",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons_IB_exportar",
  transform: "translate(-41.000000, -1525.000000)",
  fill: "#DD6625",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_aviso",
  transform: "translate(41.000000, 1525.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36,72 C16.149,72 0,55.851 0,36 C0,16.149 16.149,0 36,0 C55.851,0 72,16.149 72,36 C72,55.851 55.851,72 36,72 Z M36,3 C17.805,3 3,17.805 3,36 C3,54.195 17.805,69 36,69 C54.195,69 69,54.195 69,36 C69,17.805 54.195,3 36,3 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 35,
  y: 23,
  width: 2.97418244,
  height: 20.8192771
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 36.4870912,
  cy: 48.2805508,
  r: 1.48709122
}))));

var SvgIcAviso = function SvgIcAviso(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcAviso, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_aviso.f36e3370.svg";
export { ForwardRef as ReactComponent };